var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FCEDED"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_638_39128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1875 10.375V21.625C22.1875 21.9234 22.069 22.2095 21.858 22.4205C21.647 22.6315 21.3609 22.75 21.0625 22.75H18.25C17.9516 22.75 17.6655 22.6315 17.4545 22.4205C17.2435 22.2095 17.125 21.9234 17.125 21.625V10.375C17.125 10.0766 17.2435 9.79048 17.4545 9.5795C17.6655 9.36853 17.9516 9.25 18.25 9.25H21.0625C21.3609 9.25 21.647 9.36853 21.858 9.5795C22.069 9.79048 22.1875 10.0766 22.1875 10.375ZM13.75 9.25H10.9375C10.6391 9.25 10.353 9.36853 10.142 9.5795C9.93103 9.79048 9.8125 10.0766 9.8125 10.375V21.625C9.8125 21.9234 9.93103 22.2095 10.142 22.4205C10.353 22.6315 10.6391 22.75 10.9375 22.75H13.75C14.0484 22.75 14.3345 22.6315 14.5455 22.4205C14.7565 22.2095 14.875 21.9234 14.875 21.625V10.375C14.875 10.0766 14.7565 9.79048 14.5455 9.5795C14.3345 9.36853 14.0484 9.25 13.75 9.25Z",
    fill: "#FC5A5A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_638_39128"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.df7fd3e97284a3094bf81a7d1e62bd54.svg";
export { ForwardRef as ReactComponent };